import {queryOptions} from "@tanstack/react-query";
import {getChangelogs, loadMarkdownImages, type ChangelogResp, type Params} from "./api";
import {DEFAULT_STALE_TIME} from "services/Utils";
import * as Api from "./api";

const queries = {
  all: ["Changelog"],
  changelogs: (params: Params) =>
    queryOptions({
      queryKey: queries.all,
      queryFn: () => getChangelogs(params),
      staleTime: DEFAULT_STALE_TIME,
    }),
  images: (params?: ChangelogResp[]) =>
    queryOptions({
      queryKey: [...queries.all, "images"],
      queryFn: () => loadMarkdownImages(params),
      staleTime: DEFAULT_STALE_TIME,
      enabled: !!params,
    }),
};

export const Changelog = {
  queries,
  Api,
};
